/**
 * 登录/Token 失效时多接口并发返回错误，只应提示一次。
 * 登录成功后需 resetLoginExpiredGate()。
 */
let expiredFlowActive = false

export function resetLoginExpiredGate() {
  expiredFlowActive = false
}

/** @returns {boolean} true 表示本次应执行完整失效流程（清登录、提示、弹登录框） */
export function enterLoginExpiredFlowOnce() {
  if (expiredFlowActive) return false
  expiredFlowActive = true
  return true
}
